import { Box, Checkbox, Grid, makeStyles, Typography } from "@material-ui/core";

import IconCard from "../../iconCard";
import { COLORS } from "../../../../../theme/colors";
import { TextInput } from "../../../../../components/base";
import { CENTRAL, METER_PER_UNIT, SUBMETERS } from "../../../../../services/constants";
import centralIcon from "../../../../../assets/images/icons/workspace/central.svg";
import centralIconSelected from "../../../../../assets/images/icons/workspace/central-selected.svg";
import meterIcon from "../../../../../assets/images/icons/workspace/meter.svg";
import meterIconSelected from "../../../../../assets/images/icons/workspace/meter-selected.svg";
import submeterIcon from "../../../../../assets/images/icons/workspace/submeter.svg";
import submeterIconSelected from "../../../../../assets/images/icons/workspace/submeter-selected.svg";
import ownerIcon from "../../../../../assets/images/icons/owner.svg";
import ownerIconSelected from "../../../../../assets/images/icons/workspace/owner-selected.svg";
import pmcIcon from "../../../../../assets/images/icons/sub-meter-and-public.svg";
import pmcIconSelected from "../../../../../assets/images/icons/workspace/pmc-selected.svg";
import tenantsIcon from "../../../../../assets/images/icons/tenant.svg";
import tenantsIconSelected from "../../../../../assets/images/icons/workspace/tenants-selected.svg";

const icons = [
  {
    id: CENTRAL,
    icon: centralIcon,
    iconSelected: centralIconSelected,
    text: "Central",
  },
  {
    id: SUBMETERS,
    icon: submeterIcon,
    iconSelected: submeterIconSelected,
    text: "Submeters",
  },
  {
    id: METER_PER_UNIT,
    icon: meterIcon,
    iconSelected: meterIconSelected,
    text: "Meter per unit",
  },
];

const ownedByIcons = [
  {
    id: "BUILDING_OWNER",
    icon: ownerIcon,
    iconSelected: ownerIconSelected,
    label: "Building Owner",
  },
  {
    id: "PMC",
    icon: pmcIcon,
    iconSelected: pmcIconSelected,
    label: "TENANT",
  },
  {
    id: "TENANT",
    icon: tenantsIcon,
    iconSelected: tenantsIconSelected,
    label: "Tenants",
  },
];

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 30,
    fontWeight: 700,
  },
  iconBox: {
    display: "flex",
  },
  subHeading: {
    fontWeight: 700,
    fontSize: 18,
    marginTop: 45,
    marginBottom: 20,
  },
  paper: {
    fontSize: 18,
    marginTop: 10,
  },
  checkDiv: {
    display: "flex",
  },
  meterText: {
    marginTop: 10,
    marginLeft: 5,
    fontSize: 18,
  },
  checkStyle: {
    fontSize: 20,
    marginLeft: 10,
    "& .PrivateSwitchBase-input-285": {
      width: 30,
    },
    "& .MuiSvgIcon-root": {
      fill: COLORS.purple,
    },
  },
  Input: {
    width: 116,
    background: COLORS.white,
  },
  InputData: {
    width: 173,
    background: COLORS.white,
  },
  iconDiv: {
    display: "flex",
    "& > :nth-child(1)": {
      borderRadius: "5px 0px 0px 5px",
    },
    "& > :last-child": {
      borderRadius: "0px 5px 5px 0px",
    },
  },
  icon: {
    height: 56,
    width: 56,
    marginTop: 0,
    border: `1px solid ${COLORS.darks[0][6]}`,
    "& img": {
      width: 30,
    },
  },
  centerStyle: {
    display: "flex",
    justifyContent: "center",
    marginTop: 12,
    cursor: "pointer",
  },
  midDiv: {
    marginTop: 15,
    marginBottom: 15,
    paddingBottom: 30,
  },
  topSubHeading: {
    fontSize: 18,
    marginTop: 40,
    marginBottom: 17,
  },
}));

export const Meters = ({ data, onDataChange }) => {
  const classes = useStyles();

  const meterType = data?.type;
  const isSubMeters = meterType === SUBMETERS;
  const isCentral = meterType === CENTRAL;
  const showCheckboxUI = !meterType || meterType === CENTRAL;
  const checkedMeterIsUnitMeter = data?.unit_meters === undefined;

  const onChange = (key, value) => {
    onDataChange("meter_type", key, value);
  };

  const handleCheckMeterIsUnitMeter = (event) => {
    onChange("unit_meters", event.target.checked ? undefined : null);
  };

  return (
    <Box>
      <Typography className={classes.heading}>Now, about building electricity meters</Typography>
      <Typography className={classes.topSubHeading}>
        What is the meter type in this building?
      </Typography>
      <Box className={classes.iconBox}>
        {icons.map((data) => {
          return (
            <IconCard
              key={data.id}
              id={data.id}
              selected={meterType === data.id}
              src={meterType === data.id ? data.iconSelected : data.icon}
              text={data.text}
              style={{
                background: meterType === data.id ? COLORS.purples[0] : COLORS.white,
              }}
              onClick={(id) => onChange("type", id)}
            />
          );
        })}
      </Box>
      <Box className={classes.midDiv}>
        <Typography className={classes.subHeading}>
          {isSubMeters ? "Number of Sub-Meters" : "Number of meters"}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <Typography className={classes.paper}>Public meters:</Typography>
          </Grid>
          <Grid item xs={7}>
            <Box className={classes.iconText}>
              <Box className={classes.checkDiv}>
                <TextInput
                  type="number"
                  value={data?.public_meters || ""}
                  onChange={(v) => onChange("public_meters", v)}
                  containerStyle={meterType && !isCentral ? classes.InputData : classes.Input}
                />
                {showCheckboxUI && (
                  <>
                    <Checkbox
                      checked={checkedMeterIsUnitMeter}
                      onChange={handleCheckMeterIsUnitMeter}
                      className={classes.checkStyle}
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                    <Typography className={classes.meterText}>
                      This meter is the units meter as well
                    </Typography>
                  </>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <Typography className={classes.paper}>Owned by:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Box className={classes.iconDiv}>
              {ownedByIcons.slice(0, meterType && !isCentral ? 3 : 2).map((icon, i) => {
                return (
                  <IconCard
                    design={classes.icon}
                    centerStyle={classes.centerStyle}
                    key={i}
                    id={icon.id}
                    selected={data?.public_meters_owner === icon.id}
                    src={data?.public_meters_owner === icon.id ? icon.iconSelected : icon.icon}
                    text={icon.text}
                    style={{
                      background:
                        data?.public_meters_owner === icon.id ? COLORS.purples[0] : COLORS.white,
                    }}
                    onClick={(id) => onChange("public_meters_owner", id)}
                    inElectricityData={true}
                  />
                );
              })}
            </Box>
          </Grid>
        </Grid>
      </Box>

      {(!checkedMeterIsUnitMeter || !showCheckboxUI) && (
        <Box className={classes.midDiv}>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <Typography className={classes.paper}>Unit meters:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Box className={classes.iconText}>
                <Box className={classes.checkDiv}>
                  <TextInput
                    type="number"
                    value={data?.unit_meters || ""}
                    onChange={(v) => onChange("unit_meters", v)}
                    containerStyle={!isCentral ? classes.InputData : classes.Input}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <Typography className={classes.paper}>Owned by:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Box className={classes.iconDiv}>
                {ownedByIcons.slice(0, !isCentral ? 3 : 2).map((icon, i) => {
                  return (
                    <IconCard
                      design={classes.icon}
                      centerStyle={classes.centerStyle}
                      key={i}
                      id={icon.id}
                      selected={data?.unit_meters_owner === icon.id}
                      src={data?.unit_meters_owner === icon.id ? icon.iconSelected : icon.icon}
                      text={icon.text}
                      style={{
                        background:
                          data?.unit_meters_owner === icon.id ? COLORS.purples[0] : COLORS.white,
                      }}
                      onClick={(id) => onChange("unit_meters_owner", id)}
                      inElectricityData={true}
                    />
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};
